// import { Button, Col, Menu, Row, Tooltip, Badge, message } from "antd";
// import { Header } from "antd/lib/layout/layout";
// import React, { useEffect, useState, useRef } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { useNavigate } from "react-router-dom";
// import { signOut } from "../redux/actions/authAction";
// ;
// import {
//   AlignCenterOutlined,
//   EditOutlined,
//   FullscreenExitOutlined,
//   FullscreenOutlined,
//   LogoutOutlined,
//   SyncOutlined,
//   BellOutlined,
//   GlobalOutlined,
//   DisconnectOutlined,
//   LoadingOutlined
// } from "@ant-design/icons";
// import default_image from "../assets/images/default-user-image.jpg";
// import ImageDropdown from "../components/specificComponents/ImageDropdown";
// import { MdMenuOpen } from "react-icons/md";
// import { DAY_SHIFT_TERMINAL, DISPATCHER } from "../common/SetupMasterEnum";
// import "./style.css";
// import {
//   HubConnectionBuilder,
//   LogLevel,
//   HttpTransportType,
//   HubConnectionState,
// } from "@microsoft/signalr";
import { playNotificationSound } from "../functions/generalFunctions";
// import NewOrdersModal from "../components/PosComponentsFood/NewOrdersModal";
// import { postRequest } from "../services/mainApp.service";
// import UnlockAudioModal from "../components/NewComponents/UnlockAudioModal";

// const HeaderLayout = React.memo(({ toggleCollapse, collapsable }) => {
//   const dispatch = useDispatch();
//   const navigate = useNavigate();
//   const {
//     CompanyName,
//     Name,
//     online,
//     userBranchList,
//     RoleId,
//     UserName,
//     CompanyId,
//     UserId,
//     WebsiteUrl
//   } = useSelector((state) => state.authReducer);
//   const [date, setDate] = useState(null);
//   const [time, setTime] = useState();
//   const [isFullscreen, setIsFullscreen] = useState(false);
//   const [hubConnection, setHubConnection] = useState(null);
//   const [messages, setMessages] = useState([]);
//   const [pendingOrderCount, setPendingOrderCount] = useState(0);
//   const [isOpen, setIsOpen] = useState(false);
//   // new Orders data
//   const [newOrders, setNewOrders] = useState([]);

//   const [orderStatusList, setOrderStatusList] = useState([]);

//  const websiteUrl = localStorage.getItem("WebsiteUrl");

//  const { RefreshStats } = useSelector((state) => state.RefreshReducer);

//  const connectionRef = useRef(null);

//  const companyIdRef = useRef(CompanyId);

//   // Callback function to update newOrders
//   const handleOrdersUpdate = (updatedOrders) => {
//     setNewOrders(updatedOrders); // Update the state in the parent
//   };

//   useEffect(() => {
//     if (localStorage.getItem(DAY_SHIFT_TERMINAL))
//       setDate(
//         new Date(
//           JSON.parse(localStorage.getItem(DAY_SHIFT_TERMINAL)).Date
//         ).toLocaleDateString()
//       );
//   }, [localStorage.getItem(DAY_SHIFT_TERMINAL)]);

// //   useEffect(() => {
// //   const interval = setInterval(() => {

// //     if (!hubConnection || hubConnection.state !== HubConnectionState.Connected) {

// //         SignalRConnection();
// //       }
// //   }, 10000);

// //   return () => clearInterval(interval);
// // }, [hubConnection]);

// useEffect(() => {
//   const interval = setInterval(() => {
//     if (pendingOrderCount >= 1) {
//       playNotificationSound();
//     }
//   }, 5000);

//   return () => clearInterval(interval);
// }, [pendingOrderCount]);

//   useEffect(() => {

//     if (RefreshStats == 1)
//     {
//       fetchNewOrders(true);
//       dispatch({ type: "REFRESH_STATS", payload: 0 });
//     }
//   }, [RefreshStats]);

//   const logout = async () => {
//     try {
//     // if (hubConnection) {
//     //   await hubConnection.stop();

//     if (connectionRef?.current) {
//       connectionRef.current?.stop();

//     }
//   } catch (error) {
//     console.error("❌ Failed to stop SignalR:", error);
//   }

//     dispatch(signOut(navigate));
//   };

//   const toggleNetwork = (network) =>
//     dispatch({ type: "TOGGLE_NETWORK", payload: network });

//   const fetchNewOrders = (isInitial = false) => {
//     postRequest("GetOrder", {
//       OperationId: 1,
//       UserIP: "12.1.1.2",
//       BranchId: null,
//       AreaId: null,
//       StatusId: -1,
//       OrderNumber: "%%",
//       CustomerName: "%%",
//       CustomerPhone: "%%",
//       DateFrom: null,
//       DateTo: null,
//       CityId: null,
//       CompanyId: CompanyId ?? companyIdRef.current,
//       userId: UserId,
//       OrderModeId: null,
//       OrderSourceId: null,
//     })
//       .then((response) => {
//         if (response.data.error === true) {
//           message.error(response.data.errorMessage);
//           return;
//         }

//         if (response.data.response === false) {
//           message.error(response.data.DataSet.Table.errorMessage);
//           return;
//         }

//         const data = response.data.DataSet;

//         const { Table13 = [], Table2 = [] } = data;

//         setNewOrders(Table13 || []);
//         setOrderStatusList(Table2 || []);
//         if(!isInitial){
//           setIsOpen(true);
//         }

//       //  // ✅ Prevent re-render for pending orders
//       //  setPendingOrderCount((prevCount) => {
//       //   const newCount = Table13?.length || 0;
//       //   return prevCount !== newCount ? newCount : prevCount;
//       // });

//       setPendingOrderCount(Table13?.length || 0);

//       // if (Table13?.length > 0)
//       // {
//       //   playNotificationSound();
//       // }

//       })
//       .catch((error) => {
//         console.error("Error:", error);
//       });
//   }

//   // useEffect(() => {
//   //   if (UserId && CompanyId) {
//   //     fetchNewOrders(true);
//   //   }
//   //   // SignalRConnection();
//   //   startSignalRConnection();
//   // }, [UserId, CompanyId]); // ✅ Depend on UserId & CompanyId

//     useEffect(() => {

//     if (CompanyId != null)
//       {
//         companyIdRef.current = CompanyId;

//       fetchNewOrders(true);

//     startSignalRConnection();
//   }
//   // else
//   // {
//   //   CompanyId = companyIdRef.current;
//   // }
//   }, [CompanyId]); // ✅ Depend on UserId & CompanyId

// const startSignalRConnection = async () => {

//     // if (CompanyId == null)
//     // {
//     //   debugger;
//     //   // return;
//     // }

//   // if (CompanyId != null)
//   {
//     if (
//       connectionRef.current &&
//       connectionRef.current.state === HubConnectionState.Connected
//     ) {

//       return;
//     }

//     const connection = new HubConnectionBuilder()
//       .withUrl(process.env.REACT_APP_BASEURL + `/orderHub`, {
//         skipNegotiation: true,
//         transport: HttpTransportType.WebSockets,
//       })
//       .configureLogging(LogLevel.Information)
//       .withAutomaticReconnect([0, 1000, 4000, 7000]) // Retry delays
//       .build();

//     // Attach listener ONCE
//     connection.on("ReceiveOrderUpdate", (jsonData) => {
//       dispatch({ type: "REFRESH_STATS", payload: 1 });
//       const orderList = JSON.parse(jsonData || "[]");

//       if ([0, 1, 3, 4, 6].includes(RoleId)) {
//         const totalOrderCount = (orderList || []).reduce(
//           (sum, order) => sum + (+order.OrderCount || 0),
//           0
//         );
//         setPendingOrderCount(totalOrderCount);
//         if (totalOrderCount > 0) playNotificationSound();
//       } else {
//         const totalOrderCount = orderList
//           .filter((order) =>
//             userBranchList.some((branch) => branch.BranchId === order.BranchId)
//           )
//           .reduce((sum, order) => sum + (order.OrderCount || 0), 0);

//         setPendingOrderCount(totalOrderCount);
//         if (totalOrderCount > 0) playNotificationSound();
//       }

//       // showBrowserNotification();
//     });

//     // if (CompanyId == null)
//     // {
//     //   debugger;
//     //   // return;
//     // }

//     // Start connection
//     try {
//       await connection.start();
//       await connection.send("RegisterConnection", CompanyId ?? companyIdRef.current);
//       connectionRef.current = connection;

//     } catch (error) {
//       console.error("❌ Connection failed: ", error);
//     }
//   }
//   // else
//   // {
//   //   CompanyId = companyIdRef;
//   // }
//   };

//    useEffect(() => {

//     // Try immediately
//     startSignalRConnection();

//     // Retry every 10 seconds if not connected
//     const interval = setInterval(() => {

//       if (
//         connectionRef.current.state !== HubConnectionState.Connected
//       ) {

//         startSignalRConnection();
//         fetchNewOrders(true);
//       }
//     }, 5000);

//     return () => {
//       clearInterval(interval);
//       connectionRef.current?.stop();
//     };
//   }, []);

//   useEffect(() => {

//     if (

//         connectionRef?.current?.state === HubConnectionState.Connected
//       ) {

//        fetchNewOrders(true);

//       }

//   }, [connectionRef?.current?.state]);

//   const SignalRConnection = async (_isConnected = false) => {
//   let connection;
//     if (!_isConnected) {
//       // const url = REACT_APP_BASEURL+'/orderHub';
//       connection = new HubConnectionBuilder()
//         .withUrl(process.env.REACT_APP_BASEURL + `/orderHub`, {
//           skipNegotiation: true,
//           transport: HttpTransportType.WebSockets,
//         }) // Pass companyId as query string
//         .configureLogging(LogLevel.Information)
//         .withAutomaticReconnect([0, 2000, 5000, 10000]) // Retry delays
//         .build();
//     }

//     if (!connection || connection.state === HubConnectionState.Connected) {
//     connection.on("ReceiveOrderUpdate", (jsonData) => {

//       dispatch({ type: "REFRESH_STATS", payload: 1 });

//       const orderList = JSON.parse(jsonData);

//         if (RoleId == 0 || RoleId == 1 || RoleId == 3 || RoleId == 4 || RoleId == 6)
//         {
//           const totalOrderCount = (orderList || [])
//           .reduce((sum, order) => sum + (+order.OrderCount || 0), 0);

//           setPendingOrderCount(totalOrderCount);
//           if (totalOrderCount > 0)
//           {
//             playNotificationSound();
//           }
//         }
//         else
//         {
//             const totalOrderCount = orderList
//                 .filter(order => userBranchList.some(branch => branch.BranchId === order.BranchId))
//                 .reduce((sum, order) => sum + (order.OrderCount || 0), 0);

//             setPendingOrderCount(totalOrderCount);

//             if (totalOrderCount > 0)
//             {
//                  playNotificationSound();
//             }
//         }
//     });
//   }

//     // if (!_isConnected) {
//         if (!connection || connection.state === HubConnectionState.Connected) {
//       try {
//         var companyId = CompanyId;
//         await connection.start();
//         var result = connection.send("RegisterConnection", CompanyId);

//         setHubConnection(connection);

//       } catch (error) {
//         console.error("Connection failed: ", error);
//       }
//     }
//   };

//   const menu = (
//     <Menu>
//       <Menu.Item
//         key="1"
//         icon={<EditOutlined />}
//         onClick={() => navigate("changepassword")}
//       >
//         Change Password
//       </Menu.Item>
//       <Menu.Item key="2" icon={<LogoutOutlined />} onClick={logout}>
//         Sign Out
//       </Menu.Item>
//     </Menu>
//   );

//   function checkTime(i) {
//     if (i < 10) {
//       i = "0" + i;
//     }
//     return i;
//   }

// //   function showBrowserNotification() {

// //   if (Notification.permission === "granted") {
// //     new Notification("New Order Received", {
// //       body: `Order #`,
// //       icon: "/order-icon.png",
// //     });
// //   } else if (Notification.permission !== "denied") {
// //     Notification.requestPermission().then((permission) => {
// //       if (permission === "granted") {
// //         new Notification("New Order Received", {
// //           body: `Order #`,
// //         });
// //       }
// //     });
// //   }
// // }

//   return (
//     <Header className="mainHeader">
//       <UnlockAudioModal/>
//       <Row justify="center">
//         <Col
//           // span={9}
//           xs={18}
//           sm={9}
//           className="header-col"
//           style={{
//             justifyContent: "flex-start",
//           }}
//           align="left"
//         >
//           <div
//             style={{
//               display: "flex",
//               flexDirection: "row",
//               alignItems: "center",
//               justifyContent: "flex-start",
//               height: 57
//             }}
//           >
//             <Button
//               type="text"
//               onClick={toggleCollapse}
//               icon={
//                 <MdMenuOpen
//                   style={{
//                     fontSize: 28,
//                     transform: collapsable && "scaleX(-1)",
//                     transition: "0.2s",
//                   }}
//                 />
//               }
//               className="sidebarButton"
//               style={{ marginRight: 20 }}
//             />

//             {/* <button onClick={() => showBrowserNotification()}>
//               Test Notification
//             </button> */}

//           </div>
//         </Col>
//         <Col
//           span={6}
//           className="header-col headerCompanyName flex items-center justify-center"
//         >
//           <h2 style={{ margin: 0 }} className="text-3xl flex items-center gap-2">
//             <b>{CompanyName}</b>
//             {
//               connectionRef?.current?.state !== HubConnectionState.Connected ?
//               <DisconnectOutlined/> : <></>
//             }
//           </h2>
//         </Col>
//         <Col
//           span={3}
//           className="header-col headerCompanyName"
//           style={{
//             justifyContent: "center",
//           }}
//           align="center"
//         >
//           {}
//         </Col>
//         <Col xs={3} sm={6} align="right">
//           <Row
//             align="right"
//             style={{
//               height: 57,

//               justifyContent: "flex-end",
//             }}
//           >
//             {/* <h3 className="timeStyle">{date}</h3>
//             <h3 className="timeStyle">{time}</h3> */}

// &nbsp;
// &nbsp;
// &nbsp;

//                   <Badge
//                     count={pendingOrderCount}
//                     overflowCount={999}
//                     size="large"
//                     className="mt-3"
//                   >
//                     <Button
//                       type="danger"
//                       icon={
//                         pendingOrderCount > 0 ? (
//                           <BellOutlined className="animate-shake bell_icon" />
//                         ) : null
//                       } // ✅ Explicitly check if pendingOrderCount > 0
//                       size="large"
//                       className="flex items-center justify-center rounded-lg text-xl bg-red-500 h-10"
//                       onClick={() => fetchNewOrders()}
//                     >
//                      {
//                       pendingOrderCount > 0 ? pendingOrderCount === 1 ? "New Order" : "New Orders" : "No Orders"
//                      }
//                     </Button>
//                   </Badge>
//                   <NewOrdersModal
//                     isOpen={isOpen}
//                     setIsOpen={setIsOpen}
//                     newOrders={newOrders}
//                     onUpdateOrders={handleOrdersUpdate} // Pass the callback to the child
//                     orderStatusList={orderStatusList}
//                   />

//             <div className="mt-[6px] ml-4">
//               <ImageDropdown
//                 title={Name}
//                 menu={menu}
//                 DisplayText={UserName?.substring(0, 1).toUpperCase()}
//               />
//             </div>

//           </Row>
//         </Col>
//       </Row>
//     </Header>
//   );
// });

// export default HeaderLayout;

import { Button, Col, Menu, Row, Badge, message } from "antd";
import { Header } from "antd/lib/layout/layout";
import React, { useEffect, useState, useRef, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { signOut } from "../redux/actions/authAction";
import {
  EditOutlined,
  LogoutOutlined,
  BellOutlined,
  DisconnectOutlined,
} from "@ant-design/icons";
import ImageDropdown from "../components/specificComponents/ImageDropdown";
import { MdMenuOpen } from "react-icons/md";
import { DAY_SHIFT_TERMINAL } from "../common/SetupMasterEnum";
import "./style.css";
import {
  HubConnectionBuilder,
  LogLevel,
  HttpTransportType,
  HubConnectionState,
} from "@microsoft/signalr";
import NewOrdersModal from "../components/PosComponentsFood/NewOrdersModal";
import { postRequest } from "../services/mainApp.service";
import UnlockAudioModal from "../components/NewComponents/UnlockAudioModal";
import orderNotificationSound from "../assets/sounds/orderSound.mp3";
import NotificationSetup from "../components/general/NotificationSetup";
import NewOrderNotification from "../components/NewComponents/NewOrderNotification";

const HeaderLayout = React.memo(({ toggleCollapse, collapsable }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const {
    CompanyName,
    Name,
    userBranchList,
    RoleId,
    UserName,
    CompanyId,
    branchId,
    UserId,
  } = useSelector((state) => state.authReducer);


  const [pendingOrderCount, setPendingOrderCount] = useState(0);
  const [isOpen, setIsOpen] = useState(false);
  const [newOrders, setNewOrders] = useState([]);
  const [orderStatusList, setOrderStatusList] = useState([]);
  const { isUserInteract } = useSelector((state) => state.userInteract);
  const { RefreshStats } = useSelector((state) => state.RefreshReducer);
  const connectionRef = useRef(null);
  const companyIdRef = useRef(CompanyId);
  const previousCountRef = useRef(0);
  const audioRef = useRef(null);
  const isAudioUnlockedRef = useRef(false);

  // ===== SIMPLE AUDIO SETUP =====
  useEffect(() => {
    // Create audio element once
    audioRef.current = new Audio(orderNotificationSound); // Make sure this file exists
    audioRef.current.volume = 0.8;

    // Request notification permission on mount
    if ("Notification" in window && Notification.permission === "default") {
      Notification.requestPermission();
    }

    // Unlock audio on first user interaction
    const unlockAudio = () => {

      // TODO : I AM UNLOCKING ORDER SOUND BUT LATER I HAVE TO COMMENT IT BECUASE IT WILL CONFLICT WITH NEW ORDER NOTIFICATION SOUND SETUP
      // if (!isAudioUnlockedRef.current && (companyIdRef.current || CompanyId)) {
      //   audioRef.current
      //     .play()
      //     .then(() => {
      //       audioRef.current.pause();
      //       audioRef.current.currentTime = 0;
      //       isAudioUnlockedRef.current = true;
      //       console.log("Audio unlocked");
      //     })
      //     .catch(() => { });
      // }
    };

    // Listen for any interaction
    document.addEventListener("click", unlockAudio, { once: true });
    document.addEventListener("keydown", unlockAudio, { once: true });

    return () => {
      document.removeEventListener("click", unlockAudio);
      document.removeEventListener("keydown", unlockAudio);
    };
  }, []);

  useEffect(() => {
    if (!audioRef.current || !isAudioUnlockedRef.current) return;
    let intervalId;
    // const playSound = () => {
    //   audioRef.current.currentTime = 0;
    //   audioRef.current.play().catch(() => { });
    // };

    if (pendingOrderCount > 0) {

      // TODO : I AM UNLOCKING ORDER SOUND BUT LATER I HAVE TO COMMENT IT BECUASE IT WILL CONFLICT WITH NEW ORDER NOTIFICATION SOUND SETUP
      // playSound();
      // intervalId = setInterval(playSound, 10000);
    }

    return () => clearInterval(intervalId);
  }, [pendingOrderCount]);

  const showNotification = useCallback((count) => {

    // TODO : I AM UNLOCKING ORDER SOUND BUT LATER I HAVE TO COMMENT IT BECUASE IT WILL CONFLICT WITH NEW ORDER NOTIFICATION SOUND SETUP
    // if (audioRef.current && isAudioUnlockedRef.current) {
    //   audioRef.current.currentTime = 0;
    //   audioRef.current
    //     .play()
    //     .catch((err) => console.log("Sound play failed:", err));
    // }

  }, []);

  // ===== UPDATE REFS =====
  useEffect(() => {
    companyIdRef.current = CompanyId;
  }, [CompanyId]);

  useEffect(() => {
    if (localStorage.getItem(DAY_SHIFT_TERMINAL)) {
      setDate(
        new Date(
          JSON.parse(localStorage.getItem(DAY_SHIFT_TERMINAL)).Date
        ).toLocaleDateString()
      );
    }
  }, []);

  useEffect(() => {
    if (RefreshStats === 1) {
      fetchNewOrders(true);
      dispatch({ type: "REFRESH_STATS", payload: 0 });
    }
  }, [RefreshStats]);


  const logout = async () => {
    try {
      if (connectionRef.current) {
        await connectionRef.current.stop();
      }
    } catch (error) {
      console.error("Failed to stop SignalR:", error);
    }

    dispatch(signOut(navigate));
  };

  // ===== CALLBACK FOR CHILD COMPONENT =====
  const handleOrdersUpdate = (updatedOrders) => {
    setNewOrders(updatedOrders);
  };

  // ===== FETCH NEW ORDERS =====
  const fetchNewOrders = useCallback(
    (isInitial = false) => {
      postRequest("GetOrder", {
        OperationId: 1,
        UserIP: "12.1.1.2",
        BranchId: null,
        AreaId: null,
        StatusId: -1,
        OrderNumber: "%%",
        CustomerName: "%%",
        CustomerPhone: "%%",
        DateFrom: null,
        DateTo: null,
        CityId: null,
        CompanyId: CompanyId ?? companyIdRef.current,
        userId: UserId,
        OrderModeId: null,
        OrderSourceId: null,
      })
        .then((response) => {
          if (response.data.error === true) {
            message.error(response.data.errorMessage);
            return;
          }

          if (response.data.response === false) {
            message.error(response.data.DataSet.Table.errorMessage);
            return;
          }

          const data = response.data.DataSet;
          const { Table13 = [], Table2 = [] } = data;

          setNewOrders(Table13 || []);
          setOrderStatusList(Table2 || []);

          if (!isInitial) {
            setIsOpen(true);
          }

          const newCount = Table13?.length || 0;

          // Only notify if count INCREASED
          if (newCount > previousCountRef.current && newCount > 0) {
            console.log("Showing notification 3");
            showNotification(newCount);
          }

          previousCountRef.current = newCount;

          if (isUserInteract) {
            setPendingOrderCount(newCount);
          }
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    },
    [CompanyId, UserId, showNotification]
  );

  // ===== SIGNALR CONNECTION =====
  const startSignalRConnection = useCallback(async () => {
    if (
      connectionRef.current &&
      connectionRef.current.state === HubConnectionState.Connected
    ) return;

    const connection = new HubConnectionBuilder()
      .withUrl(process.env.REACT_APP_BASEURL + `/orderHub`, {
        skipNegotiation: true,
        transport: HttpTransportType.WebSockets,
      })
      .configureLogging(LogLevel.Information)
      .withAutomaticReconnect([0, 1000, 4000, 7000])
      .build();

    connection.on("ReceiveOrderUpdate", (jsonData) => {
      dispatch({ type: "REFRESH_STATS", payload: 1 });
      const orderList = JSON.parse(jsonData || "[]");

      let totalOrderCount = 0;

      if ([0, 1, 3, 4, 6].includes(RoleId)) {
        totalOrderCount = (orderList || []).reduce(
          (sum, order) => sum + (+order.OrderCount || 0),
          0
        );
      } else {
        totalOrderCount = orderList
          .filter((order) =>
            userBranchList.some((branch) => branch.BranchId === order.BranchId)
          )
          .reduce((sum, order) => sum + (order.OrderCount || 0), 0);
      }

      // Only notify if count INCREASED
      if (totalOrderCount > previousCountRef.current && totalOrderCount > 0) {
        showNotification(totalOrderCount);
      }

      previousCountRef.current = totalOrderCount;

      if (isUserInteract) {
        setPendingOrderCount(totalOrderCount);
      }
    });

    try {
      await connection.start();
      await connection.send(
        "RegisterConnection",
        CompanyId ?? companyIdRef.current
      );
      connectionRef.current = connection;

      console.log("SignalR Connected");
    } catch (error) {
      console.error("Connection failed: ", error);
    }
  }, [
    CompanyId,
    RoleId,
    userBranchList,
    showNotification,
    dispatch,
    isUserInteract,
  ]);

  // ===== INITIAL CONNECTION =====
  useEffect(() => {
    if (CompanyId != null) {
      fetchNewOrders(true);
      startSignalRConnection();
    }

    return () => {
      if (connectionRef.current) {
        try {
          connectionRef.current.stop();
        } catch (error) {
          console.error("Failed to stop SignalR on unmount:", error);
        }
      }
    };
  }, [CompanyId, fetchNewOrders, startSignalRConnection]);

  // ===== RECONNECTION LOGIC =====
  useEffect(() => {
    const interval = setInterval(() => {
      if (
        !connectionRef.current ||
        connectionRef.current.state !== HubConnectionState.Connected
      ) {
        console.log("🔄 Reconnecting SignalR...");
        startSignalRConnection();
      }
    }, 5000);

    return () => {
      if (connectionRef.current) {
        try {
          connectionRef.current.stop();
        } catch (error) {
          console.error("❌ Failed to stop SignalR on unmount:", error);
        }
      }
      clearInterval(interval);
    };
  }, [startSignalRConnection]);

  const isOrdersPage = location.pathname.endsWith("/customerorders");

  // ===== MENU =====
  const menu = (
    <Menu>
      <Menu.Item
        key="1"
        icon={<EditOutlined />}
        onClick={() => navigate("changepassword")}
      >
        Change Password
      </Menu.Item>
      <Menu.Item key="2" icon={<LogoutOutlined />} onClick={logout}>
        Sign Out
      </Menu.Item>
    </Menu>
  );

  return (
    <Header className="mainHeader">
      <UnlockAudioModal />
      <NotificationSetup companyId={CompanyId} branchId={branchId} />
      <Row justify="center">
        <Col
          xs={18}
          sm={9}
          className="header-col"
          style={{ justifyContent: "flex-start" }}
          align="left"
        >
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "flex-start",
              height: 57,
            }}
          >
            <Button
              type="text"
              onClick={toggleCollapse}
              icon={
                <MdMenuOpen
                  style={{
                    fontSize: 28,
                    transform: collapsable && "scaleX(-1)",
                    transition: "0.2s",
                  }}
                />
              }
              className="sidebarButton"
              style={{ marginRight: 20 }}
            />
          </div>
        </Col>
        <Col
          span={6}
          className="header-col headerCompanyName flex items-center justify-center"
        >
          <h2
            style={{ margin: 0 }}
            className="text-3xl flex items-center gap-2"
          >
            <b>{isOrdersPage ? "Live Orders" : CompanyName}</b>
            {connectionRef?.current?.state !== HubConnectionState.Connected ? (
              <DisconnectOutlined />
            ) : null}
          </h2>
        </Col>
        <Col
          span={3}
          className="header-col headerCompanyName"
          style={{ justifyContent: "center" }}
          align="center"
        ></Col>
        <Col xs={3} sm={6} align="right">
          <Row
            align="right"
            style={{
              height: 57,
              justifyContent: "flex-end",
            }}
          >
            &nbsp; &nbsp; &nbsp;
            {/* <Badge
              count={pendingOrderCount}
              overflowCount={999}
              size="large"
              className="mt-3"
            >
              <Button
                type="danger"
                icon={
                  pendingOrderCount > 0 ? (
                    <BellOutlined className="animate-shake bell_icon" />
                  ) : null
                }
                size="large"
                className="flex items-center justify-center rounded-lg text-xl bg-red-500 h-10"
                onClick={() => fetchNewOrders()}
              >
                {pendingOrderCount > 0
                  ? pendingOrderCount === 1
                    ? "New Order"
                    : "New Orders"
                  : "No Orders"}
              </Button>
            </Badge> */}
            <NewOrderNotification />
            <NewOrdersModal
              isOpen={isOpen}
              setIsOpen={setIsOpen}
              newOrders={newOrders}
              onUpdateOrders={handleOrdersUpdate}
              orderStatusList={orderStatusList}
            />
            <div className="mt-[6px] ml-4">
              <ImageDropdown
                title={Name}
                menu={menu}
                DisplayText={UserName?.substring(0, 1).toUpperCase()}
              />
            </div>
          </Row>
        </Col>
      </Row>
    </Header>
  );
});

export default HeaderLayout;
